export enum Gender {
    unspecified,
    male,
    female,
}

//Common interface that represents an object in its minimal information set
export interface EntityMinimalInfo {
    id: number;
    code: string;
    name: string;
}
